import React, { useState } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { clearRegisterSession } from '../utils/registerSession';
import RegisterPicker from './RegisterPicker';
import Register from './Register';

function RecoveryContent({ allowInvitation }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  // A verified, never-assigned account must be able to finish its explicit
  // invitation before it has any memberships to choose from.
  if (allowInvitation && location.pathname === '/register' &&
      new URLSearchParams(location.search).get('memberInvite')) return <Register />;
  return <Box sx={{ maxWidth: 560, mx: 'auto', p: 4, mt: 8 }}>
    <Typography variant="h5" component="h1" gutterBottom>Your register session needs updating</Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>Your active register or access may have changed on another device. Choose a register you can access, or sign in again.</Typography>
    <Button variant="contained" onClick={() => setOpen(true)} sx={{ mr: 2 }}>Change Register</Button>
    <Button onClick={clearRegisterSession}>Sign in again</Button>
    <RegisterPicker open={open} onClose={() => setOpen(false)} />
  </Box>;
}

export default function RegisterSessionRecovery({ allowInvitation = false }) {
  return <Router><RecoveryContent allowInvitation={allowInvitation} /></Router>;
}
